import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {CircularProgress} from '@material-ui/core';
import useUtilInformation from './../../../components/hooks/useUtilInformation';
import {matchStreamUrl} from 'helpers/functions';
import ReactPlayer from 'react-player/file';

const MediaDisplayer = ({file, route}) => {
  const {token} = useUtilInformation();
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isMicrosoftStream, setIsMicrosoftStream] = useState(false);
  const [streamID, setStreamID] = useState('');
  const [isSharepoint, setIsSharepoint] = useState(false);
  const [isGoogleDrive, setIsGoogleDrive] = useState(false);
  const [sharepointVideo, setSharepointVideo] = useState('');
  const [showGoogleDriveFallback, setShowGoogleDriveFallback] = useState(false);
  const [googleDriveLoaded, setGoogleDriveLoaded] = useState(false);

  useEffect(() => {
    // var youtube = matchYoutubeUrl(route);
    setIsLoading(true);
    var config = {Authorization: `Bearer ${token}`, responseType: 'blob'};
    axios
      .get(file, config)
      .then((resp) => {
        setUrl(window.URL.createObjectURL(resp.data));
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });

    var microsoftstream = matchStreamUrl(route);

    if (microsoftstream === false) {
      setIsMicrosoftStream(false);
    } else {
      setIsMicrosoftStream(true);
      setStreamID(microsoftstream);
    }
    if (route.includes('sharepoint')) {
      setIsSharepoint(true);
      setSharepointVideo(route);
    } else {
      setIsSharepoint(false);
      setSharepointVideo('');
    }

    if (route.includes('drive.google.com')) {
      setIsGoogleDrive(true);
    } else {
      setIsGoogleDrive(false);
    }

    setGoogleDriveLoaded(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file, route]);

  const responsiveIframe = sharepointVideo
    .replace(/width="\d+"/, 'width="100%"')
    .replace(/height="\d+"/, 'height="100%"');

  const getGoogleDriveLink = (googleRoute) => {
    if (!googleRoute) return '';
    const iframeSrcMatch = googleRoute.match(/src="([^"]+)"/i);
    return iframeSrcMatch ? iframeSrcMatch[1] : googleRoute;
  };

  const getGoogleDriveEmbedUrl = (googleRoute) => {
    if (!googleRoute) return '';

    const link = getGoogleDriveLink(googleRoute);

    const fileIdMatch = link.match(/\/file\/d\/([^/]+)/i);
    if (fileIdMatch && fileIdMatch[1]) {
      return `https://drive.google.com/file/d/${fileIdMatch[1]}/preview`;
    }

    try {
      const parsedUrl = new URL(link);
      const fileId = parsedUrl.searchParams.get('id');
      if (fileId) {
        return `https://drive.google.com/file/d/${fileId}/preview`;
      }
    } catch (error) {
      return link.replace('/view', '/preview');
    }

    return link.replace('/view', '/preview');
  };

  const googleDriveEmbedUrl = getGoogleDriveEmbedUrl(route);
  const googleDriveOpenUrl = getGoogleDriveLink(route);

  useEffect(() => {
    if (!isGoogleDrive || !googleDriveEmbedUrl) {
      setShowGoogleDriveFallback(false);
      return;
    }

    setShowGoogleDriveFallback(false);
    const fallbackTimeout = setTimeout(() => {
      if (!googleDriveLoaded) {
        setShowGoogleDriveFallback(true);
      }
    }, 6000);

    return () => clearTimeout(fallbackTimeout);
  }, [isGoogleDrive, googleDriveEmbedUrl, googleDriveLoaded]);

  return (
    <div style={{maxWidth: '960px', width: '100%'}}>
      {isMicrosoftStream ? (
        <div>
          <iframe
            allow="fullscreen"
            style={{width: '100%', height: '80vh'}}
            src={`https://web.microsoftstream.com/embed/video/${streamID}`}
            title={'microsoftstream'}></iframe>
        </div>
      ) : isSharepoint ? (
        <>
          <div
            style={{width: '100%', height: '80vh'}}
            dangerouslySetInnerHTML={{__html: responsiveIframe}}></div>
        </>
      ) : isGoogleDrive ? (
        <div>
          <iframe
            allow="fullscreen"
            style={{width: '100%', height: '80vh'}}
            src={googleDriveEmbedUrl}
            onLoad={() => {
              setGoogleDriveLoaded(true);
              setShowGoogleDriveFallback(false);
            }}
            onError={() => {
              setGoogleDriveLoaded(false);
              setShowGoogleDriveFallback(true);
            }}
            title={'googledrive'}></iframe>
          {showGoogleDriveFallback && (
            <p style={{marginTop: '10px'}}>
              No se pudo visualizar el contenido embebido.{' '}
              <a href={googleDriveOpenUrl} target="_blank" rel="noreferrer">
                Abrir en Google Drive
              </a>
            </p>
          )}
        </div>
      ) : isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
          }}>
          <CircularProgress />
        </div>
      ) : (
        <div style={{position: 'relative', paddingTop: '56.25%'}}>
          <ReactPlayer
            url={url}
            controls
            width="100%"
            height="100%"
            style={{position: 'absolute', top: 0, left: 0}}
          />
        </div>
      )}
    </div>
  );
};

export default MediaDisplayer;
